import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';
import { TranslateModule } from '@ngx-translate/core';
import { JoinPipe } from '../../../../sb-tools/typescript/pipes/join.pipe';

@Component({
    selector: 'app-recipient-confirmation-modal',
    templateUrl: './recipient-confirmation-modal.component.html',
    styleUrls: ['./recipient-confirmation-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, JoinPipe],
})
export class RecipientConfirmationModalComponent implements OnDestroy {
    bccUsers: string[] = [];
    ccUsers: string[] = [];
    onClose: Subject<boolean> = new Subject();
    toUsers: string[] = [];

    constructor(private modalRef: BsModalRef) {}

    confirm(): void {
        this.onClose.next(true);
        this.onClose.complete();

        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }

    ngOnDestroy() {
        this.onClose.next(false);
        this.onClose.complete();
    }
}
